export const ClaudeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      color="currentColor"
    >
      <path
        d="m12.707,12.707l-2.293,2.293-1.414-1.414,2.293-2.293c.391-.391.391-1.023,0-1.414s-1.023-.391-1.414,0l-2.293,2.293-1.879-1.879c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l.352.352-1.134,1.135c-1.77,1.769-1.982,4.515-.638,6.519l-2.58,2.58c-.391.391-.391,1.023,0,1.414.195.195.451.293.707.293s.512-.098.707-.293l2.58-2.58c.865.58,1.868.871,2.871.871,1.321,0,2.642-.503,3.647-1.509l1.135-1.134.352.352c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414l-1.879-1.879,2.293-2.293c.391-.391.391-1.023,0-1.414s-1.023-.391-1.414,0Zm-3.315,6.368c-1.232,1.23-3.234,1.23-4.467,0-1.231-1.231-1.231-3.235,0-4.467l1.134-1.135,4.467,4.467-1.135,1.134ZM23.707.293c-.391-.391-1.023-.391-1.414,0l-2.58,2.58c-2.004-1.344-4.749-1.132-6.519.638l-1.135,1.135-.353-.353c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l8,8c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414l-.353-.353,1.135-1.135c1.77-1.769,1.982-4.515.638-6.519l2.58-2.58c.391-.391.391-1.023,0-1.414Zm-4.632,9.099l-1.135,1.135-4.467-4.467,1.135-1.135c1.232-1.23,3.234-1.23,4.467,0,1.231,1.231,1.231,3.235,0,4.467Z"
        fill="currentColor"
      />
    </svg>
  );
};
